import React, { useState } from 'react';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import {
  Button,
  Grid,
  CircularProgress,
  Typography,
  Alert,
} from '@mui/material';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import { sendRepentance } from '@shared/services/services';
import StyledTextField from '@shared/components/StyledTextField';

const validationSchema = Yup.object({
  full_name: Yup.string().required('Este campo es obligatorio'),
  dni: Yup.string().required('Este campo es obligatorio'),
  email: Yup.string()
    .email('Email inválido')
    .required('Este campo es obligatorio'),
  phone: Yup.string().required('Este campo es obligatorio'),
  reservation_number: Yup.string().required('Este campo es obligatorio'),
  reason: Yup.string()
    .max(300, 'El motivo no puede superar los 300 caracteres')
    .required('Este campo es obligatorio'),
});

const RepentanceRequestForm = ({ handleClose }) => {
  const [submitted, setSubmitted] = useState(false);
  const [error, setError] = useState(false);

  const formik = useFormik({
    initialValues: {
      full_name: '',
      dni: '',
      email: '',
      phone: '',
      reservation_number: '',
      reason: '',
    },
    validationSchema,
    onSubmit: async (values, { setSubmitting }) => {
      try {
        setError(false);
        await sendRepentance(values);
        setSubmitted(true);
      } catch (err) {
        setError(true);
      } finally {
        setSubmitting(false);
      }
    },
  });

  if (submitted) {
    return (
      <Grid item xs={12} sx={{ height: '120px' }}>
        <Alert
          severity="success"
          icon={<CheckCircleIcon fontSize="small" />}
          sx={{ fontSize: '18px' }}
        >
          Se envió el reclamo para su revisión, a la brevedad nos pondremos en
          contacto con usted.
        </Alert>

        <Grid item xs={12} sx={{ textAlign: 'right' }}>
          <Button
            variant="contained"
            color="primary"
            onClick={handleClose}
            sx={{ height: '40px', width: '100px', mt: 2 }}
          >
            Cerrar
          </Button>
        </Grid>
      </Grid>
    );
  }

  return (
    <form onSubmit={formik.handleSubmit}>
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <Typography variant="subtitle1">
            Datos del Titular de la Compra
          </Typography>
        </Grid>

        {error && (
          <Grid item xs={12}>
            <Alert severity="error">
              Ocurrió un error al enviar el reclamo. Intente nuevamente.
            </Alert>
          </Grid>
        )}

        <Grid item xs={12}>
          <StyledTextField
            formik={formik}
            name="full_name"
            label="Nombre y Apellido"
          />
        </Grid>

        <Grid item xs={12} sm={6}>
          <StyledTextField formik={formik} name="dni" label="DNI" />
        </Grid>

        <Grid item xs={12} sm={6}>
          <StyledTextField formik={formik} name="email" label="Email" />
        </Grid>

        <Grid item xs={12} sm={6}>
          <StyledTextField
            formik={formik}
            name="phone"
            label="Teléfono de Contacto"
          />
        </Grid>

        <Grid item xs={12} sm={6}>
          <StyledTextField
            formik={formik}
            name="reservation_number"
            label="Número de Reserva"
          />
        </Grid>

        <Grid item xs={12}>
          <StyledTextField
            formik={formik}
            name="reason"
            label="Motivo"
            multiline
            minRows={3}
            inputProps={{ maxLength: 300 }}
            helperText={
              formik.touched.reason && formik.errors.reason
                ? formik.errors.reason
                : `${formik.values.reason?.length || 0}/300`
            }
          />
        </Grid>

        <Grid item xs={12} sx={{ textAlign: 'right' }}>
          <Button
            type="submit"
            variant="contained"
            color="primary"
            disabled={formik.isSubmitting}
            sx={{ height: '40px', width: '100px' }}
          >
            {formik.isSubmitting ? <CircularProgress size={20} /> : 'Enviar'}
          </Button>
        </Grid>
      </Grid>
    </form>
  );
};

export default RepentanceRequestForm;
